import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Modal

} from "reactstrap";

import { Field, reduxForm } from "redux-form";
import API from "../../../Common/api";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MDBDataTable } from "mdbreact";
//import API from "../../../Common/api";
import _ from "lodash";
import "./styles.css";
import * as FileSaver from 'file-saver';
import LoadingOverlay from "react-loading-overlay";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSV from '../../../Common/exportcsv';
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.svg'


var url = window.location.hostname;
var port = window.location.port;
var data_img = [];
var From_Date_val = "";
var to_Date_val = "";


const exportToCSVData = (csvData, fileName) => {
  const ws = XLSX.utils.json_to_sheet(csvData);
  var Heading = []
  Heading = [['Warehouse code',	'Brand','Sub group number',	'Order Number',	'Order Date',	'Retailer Code',	'Zone',	'Jarvis Product Id',	'Base Pack Code',	'SKU7 code',	'Product Name',	'MRP',	'UPC',	'CLD Put Qty',	'Loose Put Qty',	'Put Operator ID',	'Close Operator ID',	'Product Put Time',	'Sorting Start Time',	'Sorting Close Time',	'Box ID']];
  

  exportToCSV(csvData, fileName, Heading)

  
}

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.getCookie = this.getCookie.bind(this);
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);

    this.state = {
      orderdata: [],
      ShowpopupLoader: false,
      showFromErr: false,
      showToErr: false,
      showFilter: false,
      ShowConfirmLoader: false,
      btnDisabled: true,
      isDisabledSearch: false,
      filtered_orderData: "",
      loader1: false,
      showVariant: false,
      isDisabledApply: false,
      disabledBtn: false,
      showData: false,
      showErrorMessage: false,
      view_type: "",
      fromdate: "",
      todate: "",
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
      sku: "",
      order: "",
      subgroup :"",
      tableRowsMap: [],
      showFetchDispatchData: false,
      filter_model : false,
      from_date: null,
      to_date: null,
      showFromErr: false,
      showToErr: false,
      dateRangeError: false, 
      toDateError: "",
      fromDateError: ""
    };
  }

  onOrderChange = (evt) => {
    this.setState({
      order: evt.target.value,
    });
  };

  onSKUChange = (evt) => {
    this.setState({
      sku: evt.target.value,
    });
  };

  onSubGroupChange = (evt) => {
    this.setState({
      subgroup: evt.target.value.trim(),
    });
  };

  convertDate = (inputFormat) => {
    function pad(s) {
      return s < 10 ? "0" + s : s;
    }
    var d = new Date(inputFormat);
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join("-");
  };

  FromDateChange = date => {
    this.setState({
      from_date: date,
      dateRangeError: false, // Reset the error when "From Date" changes
      dateOrderError: false, // Reset the date order error
    });
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      From_Date_val = "";
    }


    if (this.state.to_date && date) {
      const fromDate = new Date(date);
      const toDate = new Date(this.state.to_date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24); // Convert to days

      // If the difference is less than 15 days, show error
       if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        this.setState({
          dateOrderError: true,
           from_date: null, 
           todateError: "",
           fromDateError: "From Date should be less than To Date"
        });
      }
      console.log("dateOrderError",dayDifference)
      if (dayDifference > 15) {
        this.setState({
          dateOrderError: true, // Show error if the date range is less than 15 days
          from_date: null, // Reset From Date if the range is invalid
          fromDateError: "From Date should always be within 15 days of the To Date"
        });
      }
    }
  };

  // To date change handler
  ToDateChange = date => {
    if (date && this.state.from_date) {
      const fromDate = new Date(this.state.from_date);
      const toDate = new Date(date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24);
      if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        console.log("fromDate", fromDate, "toDate", toDate)
        this.setState({
          dateRangeError: true,
           to_date: null, 
           todateError: "",
           toDateError: "To Date should be greater than From Date"
        });
        return false;
      }

      if (dayDifference > 15) {
        this.setState({
          dateRangeError: true,
          toDateError: "You cannot select more than 15 days",
          to_date: null, // Reset to_date if range exceeds 15 days
        });
      } else {
        this.setState({
          to_date: date,
          showToErr: false,
          dateRangeError: false,
        });
      }
    } else {
      this.setState({
        to_date: date,
        showToErr: false,
        dateRangeError: false,
      });
    }

    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      to_Date_val = "";
    }
  };

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  SuccessConfirmoktoggle() {
    this.setState({
      SuccessConfirmmodal: false,
    });

    window.location.reload();
    /*window.location.href="/putaway/printPutaway";*/
  }
  toggleOK = () =>  {
    this.setState({
      filter_model : false,
    });}

  fetchDispatch = (order_no) => {
    this.setState({
      //loading_overlay: true,
      loading: true,
    });
    if ( !(From_Date_val) && !(to_Date_val)) {
      this.setState({
        filter_model :true,
        loading: false,
      })
    }
    else{
        
        const payload = {
          to_date: to_Date_val,
          from_date: From_Date_val,   
        };
        addAnalytics('Report', 'View Mis Packing Task Report', payload);

        API.post("/mis/packing-report/", { param: payload })
          .then((response) => response.data)
          .then((data) => {

            if (data.length == 0) {

              this.setState({
                dispatch_status: true,
                // showFetchDispatchData: true,
                loading_overlay: false,
                loading: false,
              });
              return false;
            }
            else{
              this.setState({
                tableRowsMap: this.assembleDispatchData(data.data),
                showFetchDispatchData: true,
                dispatch_status: false,
                loading: false,
              });}

          })
          .catch(function (error) { });
      };}
  
  assembleDispatchData = (data) => {
    let posts = data.map((post) => {
      var status = "";
      if (post.status == true) {
        status = "Active";
      } else { status = " Not Active" }
      return {
        warehouse_code: post.warehouse_code,
        brand : post.brand,
        sub_group_number: post.sub_group_number ,
        order_number: post.order_number ,
        order_date: post.order_date ,
        retailer_code: post.retailer_code ,
        zone: post.zone ,
        jarvis_product_id: post.jarvis_product_id ,
        base_pack_code: post.base_pack_code ,
        sku7_code: post.sku7_code ,
        product_name: post.product_name ,
        mrp: post.mrp ,
        upc: post.upc ,
        cld_put_qty: post.cld_put_qty ,
        loose_put_qty: post.loose_put_qty ,
        put_operator_id: post.put_operator_id ,
        close_operator_id: post.close_operator_id ,
        product_put_time: post.product_put_time ,
        sorting_start_time : post.sorting_start_time ,
        sorting_close_time: post.sorting_close_time ,
        box_id: post.box_id ,

      };
    });


    this.setState({
      loading_overlay: false,
      filtered_orderData: posts,
      orderData: posts,
      // posts : posts,
    });

    return posts;
  };

  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData });
    } else {

      var value = this.state.orderData.filter(
        (val) => {
          return Object.keys(val).some(key => {
            var data = ""
            if (val[key] == null) {
              data = ""
            }
            else {
              data = val[key]
            }

            return data.toString().toLowerCase().includes(evt.toLowerCase())
          })
        }
      );

      this.setState({
        filtered_orderData: value,
      });
    }
  };


  render() {
    const { handleSubmit, reset, t } = this.props;

    const dispatchData = {
      columns: [
       
        {
          label: "warehouse code",
          field: "warehouse_code",
          width: 200,
        },
        {
          label: "Brand",
          field: "brand",
          width: 140,
        },
        {
          label: "Sub Group Number ",
          field: "sub_group_number",
          width: 140,
        },
        {
          label: "Order Number",
          field: "order_number",
          width: 180,
        },
        {
          label: "Order Date",
          field: "order_date",
          width: 180,
        },
        {
          label: "Retailer Code",
          field: "retailer_code",
          width: 180,
        },
        {
          label: "Zone",
          field: "zone",
          width: 160,
        },
        {
          label: "Jarvis Product Id",

          field: "jarvis_product_id",
          width: 180,
        },
        {
          label: "Base Pack Code",

          field: "base_pack_code",
          width: 180,
        },
        {
          label: "SKU7 code",

          field: "sku7_code",
          width: 160,
        },
        {
          label: "Product Name",

          field: "product_name",
          width: 200,
        },
        {
          label: "MRP",

          field: "mrp",
          width: 120,
        },
        {
          label: "UPC",

          field: "upc",
          width: 120,
        },

        {
          label: "CLD Put Qty",

          field: "cld_put_qty",
          width: 120,
        },
        {
          label: "Loose Put Qty",

          field: "loose_put_qty",
          width: 120,
        },
        {
          label: "Put Operator ID",

          field: "put_operator_id",
          width: 180,
        },
        {
          label: "Close Operator ID",

          field: "close_operator_id",
          width: 180,
        },
        {
          label: "Product Put Time",

          field: "product_put_time",
          width: 140,
        },
        {
          label: "Sorting Start Time",

          field: "sorting_start_time",
          width: 140,
        },
        {
          label: "Sorting Close Time",

          field: "sorting_close_time",
          width: 140,
        },
        {
          label: "Box ID",

          field: "box_id",
          width: 180,
        }
        
      ],

      rows: this.state.tableRowsMap,
    };
    
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <LoadingOverlay active={true} spinner text="wertyui" />
        )}
        <Card>
          <Overlay>
            <form className="form">
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                <span className="filter_title">Filters</span>
              </div>
                <div>
                  <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                    <span className="date_title">From Date</span>
                    <div style={{ position: 'relative' }}>
                      
                      <DatePicker
                        selected={this.state.from_date}
                        onChange={this.FromDateChange}
                        className="ledger_fromdate"
                        placeholderText="From Date"
                        format='yyyy-MM-dd'

                      />
                      <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>

                      {this.state.showFromErr && (
                        <span style={{ color: "red", fontSize: 11 }}>
                          Please Select From Date
                        </span>
                      )}
                      {this.state.dateOrderError && (
                        <span style={{ color: 'red', fontSize: 11 }}>{this.state.fromDateError}</span>
                      )}
                    </div>
                  </div>
                  <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                    <span className="date_title">From Date</span>
                    <div style={{ position: 'relative' }}>
                      <DatePicker
                        selected={this.state.to_date}
                        onChange={this.ToDateChange}
                        className="ledger_todate"
                        placeholderText="To Date"
                      />
                      <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>
                      {this.state.showToErr && (
                        <span style={{ color: "red", fontSize: 11 }}>
                          Please Select To Date
                        </span>
                      )}

                      {this.state.showToErr &&
                        <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
                      }
                      {this.state.dateRangeError &&
                        <span style={{ color: 'red', fontSize: 11 }}>{this.state.toDateError}</span>
                      }
                    </div>
                  </div>
                </div>

              <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable1 "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_view"
                    onClick={() => this.fetchDispatch(this.state.order_no)}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </Button>
               
                {/* {(this.state.detailed_view && */}
                  <Button
                    type="button"
                    className="btn btn-primary-outline"
                    style={{
                        cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                        backgroundColor: '#FFFFFF',
                        color: '#333333', // Set text color
                        display: 'flex',   // Use flexbox to align image and text
                        alignItems: 'center' // Center items vertically
                    }}
                    id="button_download"
                     onClick={(e) => exportToCSVData(this.state.filtered_orderData, "Packing Task Detailed Report")}>
                    <img
                        src={DownloadIcon}
                        alt="Download"
                        style={{ width: '22px' }} // Adjust size as needed
                    />
                  Download
                </Button>

              </ButtonToolbar>
            </div>
              
          </form>
        </Overlay>

          {!this.state.showFetchDispatchData && (
            <div style={{width: '80%', textAlign: 'center', padding: '12%'}}>
               <img style={{width: '10%'}} src={EmptyDataIcon} />
                <p className="noDataTextStyle">
                Choose your filters from the available options. The data will display
              </p>
              <p className="noDataTextStyle2">
                 here once the filters have been applied.
              </p>
            </div>
          )}

          {this.state.showFetchDispatchData && (

            <div>
              <div>

                {From_Date_val &&
                  <div className="date-container">
                   {From_Date_val}
                  </div>
                }

                {to_Date_val &&
                  <div className="date-container">
                   {to_Date_val}
                  </div>
                }

                {this.state.order &&
                  <div className="date-container">
                   {this.state.order}
                  </div>
                }

                {this.state.sku &&
                  <div className="date-container">
                   {this.state.sku}
                  </div>
                }

                {this.state.sub_group &&
                  <div className="date-container">
                   {this.state.sub_group}
                  </div>
                }

                {this.state.view_type &&
                  <div className="date-container">
                   {this.state.view_type}
                  </div>
                }




              </div>
              <div style={{ marginTop: '4%', paddingTop: 20, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              
                <div
                  className="dispatchData stock_check_data"
                  style={{ marginTop: -27 }}
                >
                  
                  <MDBDataTable
                    scrollX
                    scrollY
                    sortable={false}
                    maxHeight="390px"
                    // displayEntries={false}
                    striped
                    bordered
                    onSearch={this.filterData}
                    data={dispatchData}
                  />
                </div>
              </div>
            </div>
          )}

        </Card>
        <Modal isOpen={this.state.filter_model} >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              // onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-down modal__title-icon"
              style={{ color: "red" }}
            />
            <h4> One of the Filter is Mandatory</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOK}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));